import { Controller } from 'react-hook-form';
import { AutocompleteMultiple, InputText, Select, SidePanelRow } from '@ui/src';
import { PanelRoleCreateProps } from './types';

import cn from './styles.module.css';

const PanelRoleCreate = ({
  control,
  errors,
  userList,
  templates,
  templatesVisible,
}: PanelRoleCreateProps): React.JSX.Element => (
  <div className={cn.sidepanel}>
    <SidePanelRow caption="Name">
      <Controller
        control={control}
        name="name"
        render={({ field: { onChange, value } }) => (
          <InputText
            placeholder="Enter name..."
            name="name"
            value={value}
            onChange={onChange}
            error={errors?.name?.message}
            tabIndex={0}
          />
        )}
      />
    </SidePanelRow>
    {templatesVisible && (
      <SidePanelRow caption="Notification template">
        <Controller
          control={control}
          defaultValue=""
          name="notificationTypeTemplateId"
          render={({ field: { onChange, value, name } }) => (
            <Select
              placeholder="Select template..."
              name={name}
              value={value}
              onChange={onChange}
              error={errors?.notificationTypeTemplateId?.message}
              list={templates}
              fullWidth
            />
          )}
        />
      </SidePanelRow>
    )}
    <SidePanelRow caption="Assign to users">
      <Controller
        control={control}
        name="userIds"
        render={({ field: { onChange, value } }) => (
          <AutocompleteMultiple
            value={value}
            list={userList}
            name="userIds"
            onChange={onChange}
            placeholder="Select users..."
            tabIndex={0}
            fullWidth
          />
        )}
      />
    </SidePanelRow>
  </div>
);

export default PanelRoleCreate;
